/**
 * Helper : parents
 * @param el
 * @param selector
 * @returns {*[]}
 */
export function parents(el, selector) {
    const parents = [];
    while ((el = el.parentNode) && el !== document) {
        if (!selector || el.matches(selector)) parents.push(el);
    }
    return parents;
}

export const startPageOnTop = () => {
    // Force to start page on top
    if (history.scrollRestoration) {
        history.scrollRestoration = 'manual';
    } else {
        window.onbeforeunload = function () {
            window.scroll({top: 0, left: 0});
        }
    }
}

/**
 * Move element to bottom
 */
export function moveElementBottom() {
    const elementsToMove = document.querySelectorAll('.move-bottom-js');
    if (elementsToMove.length) {
        elementsToMove.forEach(el => {
            el.remove()
            document.body.appendChild(el)
        })
    }
}